import React, { useState } from "react";

import AppBox from "@/components/AppBox";
import AppInput from "@/components/AppInput";
import AppButton from "@/components/AppButton";
import AppCard from "@/components/AppCard";
import AppText from "@/components/AppText";
import NoteItem from "./NoteItem";
import AppIcon from "@/components/AppIcon";

interface Note {
  created_at: string;
  note: string;
  id: number;
}

interface AppLeadNotesProps {
  notes: Note[];
  onSubmit: (note: string) => void;
  onUpdateNote: (id: number, updatedNote: string) => void;
  onDeleteNote: (id: number) => void;
}

const AppLeadNotes: React.FC<AppLeadNotesProps> = ({ notes, onSubmit, onUpdateNote, onDeleteNote }) => {
  const [textFieldVisible, setTextFieldVisible] = useState(false);
  const [form, setForm] = useState({ note: "" });

  const handleSubmitNote = () => {
    if (form.note.trim()) {
      onSubmit(form.note);
      setForm({ note: "" });
      setTextFieldVisible(false);
    }
  };

  const handleToggleTextField = () => {
    setTextFieldVisible((prev) => !prev);
    setForm({ note: "" });
  };

  return (
    <AppCard className="h-full overflow-hidden">
      {/* Header */}
      <AppBox justify="between" align="center" className="mb-4">
        <AppText variant="h3">Notes</AppText>
        <AppBox>
          <AppButton variant="text" onClick={handleToggleTextField}>
            {textFieldVisible ? "Cancel" : "+ Add Note"}
          </AppButton>
        </AppBox>
      </AppBox>

      {/* Add Note Form */}
      {textFieldVisible && (
        <AppBox column gap={4} className="mb-4">
          <AppInput
            label="Add Note"
            multiline
            rows={4}
            value={form.note}
            fullWidth
            onChange={(value: any) => setForm({ note: value })}
          />
          <AppBox justify="center" gap={4}>
            <AppButton onClick={handleSubmitNote}>Submit</AppButton>
            <AppButton variant="outlined" onClick={handleToggleTextField}>
              Cancel
            </AppButton>
          </AppBox>
        </AppBox>
      )}

      {/* Notes Container */}
      <AppBox
        column
        className="overflow-y-auto pt-2 -mx-4 px-4 flex-1 h-0"
        style={{ gap: textFieldVisible ? "1rem" : "0.5rem" }}
      >
        {/* Render Notes */}
        {notes && notes.length > 0 ? (
          notes.map((note) => (
            <NoteItem
              key={note.id}
              note={note}
              onSave={onUpdateNote}
              onDelete={onDeleteNote}
            />
          ))
        ) : (
          !textFieldVisible && (
            <AppBox column align="center" gap={4} className="text-center">
              <AppText>There are no notes for this lead.</AppText>
              <AppText>
                Create the first note by clicking the button above.
              </AppText>
            </AppBox>
          )
        )}
      </AppBox>
    </AppCard>
  );
};

export default AppLeadNotes;